import React, {Component} from 'react';

import locales from '../../locales';
import {autoBooking} from '../../config/constants';
import {IProps} from './IReservesSystemSettings';
import {TNewInfo} from '../../types/IRestaurantInfoStore';
import ReservesSystemSettings from '../../components/ReservesSystem/ReservesSystemSettings';

class ReservesSystemSettingsCont extends Component<IProps> {
  /** @description Ручка для переключения приёма брони */
  handleSwitchBookingProcessor = (data: TNewInfo) => {
    const {currentRestaurant, switchBookingProcessor} = this.props;
    const processorType = data.value === locales.t('settings.api')
      ? autoBooking.api
      : autoBooking.cashBox;

    if (currentRestaurant) {
      switchBookingProcessor({
        restaurantId: currentRestaurant.id,
        processorType,
      });
    }
  };

  /** @description Ручка для редактирования полей ресторана */
  handleUpdateRestaurantSettings = (data: TNewInfo) => {
    const {currentRestaurant, updateRestaurantInfo} = this.props;

    if (currentRestaurant) {
      const updateData = {
        ...data,
        currentRestaurant,
      };

      updateRestaurantInfo(updateData);
    }
  };

  /** @description Ручка для переключение типа графика приёма резервов */
  handleSwitchReserveSchedule = () => {
    const {switchReserveSchedule, isActiveRestaurantSchedule} = this.props;
    switchReserveSchedule(!isActiveRestaurantSchedule);
  };

  render() {
    const {
      isActiveRestaurantSchedule,
      currentRestaurant,
      restaurantWorkTimes,
    } = this.props;

    if (!currentRestaurant) {
      return null;
    }

    return (
      <ReservesSystemSettings
        currentRestaurant={currentRestaurant}
        isActiveRestaurantSchedule={isActiveRestaurantSchedule}
        handleSwitchBookingProcessor={this.handleSwitchBookingProcessor}
        handleUpdateRestaurantSettings={this.handleUpdateRestaurantSettings}
        handleSwitchReserveSchedule={this.handleSwitchReserveSchedule}
        restaurantWorkTimes={restaurantWorkTimes}
      />
    );
  }
}

export default ReservesSystemSettingsCont;
